import { updateNavigationCollapsed as updateNavigationCollapsedAction } from '../actions/layout';

export function updateNavigationCollapsed(isCollapsed) {
  return dispatch => {
    dispatch(updateNavigationCollapsedAction(isCollapsed));
  };
}
